/* ===========================================================
   Lucraa — Landing · Confiança e dados
   Destrava a objeção nº1 ("vou dar OAuth aos meus dados financeiros?")
   antes do preço. Conteúdo do array SEGURANCA (landing.data.ts).
   Cada card carrega `.card` (regra de ouro do tema escuro).
   =========================================================== */
import { Icon } from "../../components/ui.jsx";
import { SEGURANCA } from "./landing.data";
import { LpSectionHead } from "./lp";

export function LandingSeguranca() {
  return (
    <section id="seguranca" className="lp-section" aria-labelledby="lp-h2-seguranca">
      <div className="lp-wrap">
        <LpSectionHead
          center
          eyebrow="Seus dados"
          titleId="lp-h2-seguranca"
          title="Acesso oficial, somente leitura, revogável em um clique."
          lead="O Lucraa conecta pelas APIs oficiais e só lê o que precisa para calcular o seu lucro. Não pede senha, não altera nada na sua loja."
        />
        <ul className="lp-trust lp-stagger">
          {SEGURANCA.map((s) => (
            <li key={s.titulo} className="card lp-card">
              <span className="lp-trust-ic">
                <Icon name={s.icone} size={20} color="var(--lucro)" />
              </span>
              <h3 style={{ fontSize: 16 }}>{s.titulo}</h3>
              <p
                style={{
                  fontSize: 13.5,
                  color: "var(--ink-soft)",
                  marginTop: 8,
                  lineHeight: 1.5,
                }}
              >
                {s.desc}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
